import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { SummaryNetRevenueDailyItem, SummaryNetRevenueHourlyItem } from "../../../../graphql/types"
import { BreakdownByHourItem, TrendingDataItem } from "./types"

export const isTabletResolution = (width: number) => width < 700

export const transformSummaryNetRevenueHourlyItemToBreakdownByHourItem = (
    data: Maybe<SummaryNetRevenueHourlyItem[]>
): BreakdownByHourItem[] => {
    if (!data) {
        return []
    }

    return data.map((item: SummaryNetRevenueHourlyItem) => ({
        hour: item.hour,
        revenueReceived: item.revenueReceived,
        revenueReceivable: item.revenueReceivable,
        createdOrders: item.createdOrders,
        openOrders: item.openOrders,
    }))
}

export const transformSummaryNetRevenueDailyItemToTrendingDataItem = (
    data: Maybe<SummaryNetRevenueDailyItem[]>
): TrendingDataItem[] => {
    if (!data) {
        return []
    }

    return data.map((item: SummaryNetRevenueDailyItem) => ({
        date: item.date,
        netRevenueOpened: item.netRevenueOpened,
        netRevenueClosed: item.netRevenueClosed,
        orderCountOpened: item.orderCountOpened,
    }))
}
